export function ensureUnreachable(value: never, message?: string): never {
  throw new Error(
    message || `Unreachable code hit with value ${String(value)}`,
  );
}

// use this function to determine whether or not a call to localStorage will succeed
export function storageAvailable() {
  let storage;
  try {
    storage = window.localStorage;
    const x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return (
      e instanceof DOMException &&
      // everything except Firefox
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' ||
        // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage &&
      storage.length !== 0
    );
  }
}

// Clamps number within the lower bound min and the upper bound max
export function clamp(number: number, min: number, max: number) {
  return Math.max(min, Math.min(number, max));
}
